module.exports = __webpack_public_path__ + "img/郑羽佳.441b25ff.jpg";